import "core-js";
import "regenerator-runtime/runtime";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";

import $ from "jquery";
import "jquery-serializejson";
import svg4everybody from "svg4everybody";
import "objectFitPolyfill";
import {handleNav, handleStickyNav} from "util/nav";

import Page from "webPage/Page";

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $('html').addClass('ie11');
    }

    appHeight();
    svg4everybody();
    handleNav();
    handleStickyNav();

    Page.init();
});

function appHeight() {
    let doc = document.documentElement;
    doc.style.setProperty('--screen-height', $(window).innerHeight() + 'px');
}

export function svg_include(icon, suffix = '') {
    return '<svg><use xlink:href="/wp-content/themes/anka/includes/svg-icons.svg?#' + icon + '"></use></svg>';
}

window.$ = window.jQuery = $;
window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;